import React, {Component} from "react";
import {Col, Row,} from "reactstrap";
import ProgressBar from "progressbar.js";
import ReactAudioPlayer from 'react-audio-player';
import "../../assets/css/animation.css";

import {connect} from "react-redux";
import {OTSession, OTStreams} from "opentok-react";
import OT from "@opentok/client";
import className from "classnames";
import * as actions from "../../actions";
import {TOKBOX_APIKEY} from "../../util/constants";
import Publisher from "../../components/tokbox/Publisher";
import Subscriber from "../../components/tokbox/Subscriber";
import ExitSessionModal from "../../components/modal/ExitSessionModal";
import {
    checkValidBroadcast,
    endCountdownFunc,
    endOTSessionCountdown,
    getSessionStatus,
    startCountdownFunc,
    startOTSessionCountdown
} from "../../util/broadcast/start_broadcast";
import {
    hideModal,
    isEmpty,
    LogException,
    makeUserOnline,
    navigate,
    removeAllModalPopUps,
    showModal,
    updateVideoDimensions,
    vuepayAlert,
    vuePayLog,
} from "../../util/utility";
import {getData, LOGIN, USER_DATA} from "../../util/storage";
import {decodeEncryptedIdForBroadcaster, getEncryptedIdForBroadcaster,} from "../../util/broadcast_util";
import {requestFullScreen} from "../../util/broadcast/countdown";
import {getConnectionObject, getSignalObject, removeConnectionObject,} from "../../util/broadcast/common";
import InviteForSessionModal from "../../components/modal/InviteForSessionModal";
import {
    createBroadcastOnFirestore,
    createPrivateSessionRecord,
    subscribeToFireStore,
    subscribeToFireStoreForOneToOneRequest,
    subscribeToFireStoreForTipGoal,
    subscribeToPrivateFireStore,
    unsubscribeToFireStore,
    updatePrivateSessionRequestStatus,
} from "../../util/firebase/firestore";
import * as _ from "lodash";
import {updateJWTToken} from "../../util/broadcast/create";
import {checkIfCreatePrivateBroadcast} from "../../util/broadcast";
import CommonModal from "../../components/modal/CommonModal";
import cross from "../../assets/images/cross.svg";
import assets from "../../util/assets";
import {
    ChangeBroadcastComponent,
    ChatComponent,
    RequestComponent,
    TipComponent,
    TipGoalComponent,
    TopSection
} from "../../components/Video";

const screename = "StartBroadcast";
class StartBroadcast extends Component {
    constructor(props) {
        super(props);

        this.rap = null;
        this.publisherRef = null;
        this.otSession = React.createRef();
        this.state = {
            api_key: TOKBOX_APIKEY,
            broadcast: null,
            videoDevices: [],
            audioDevices: [],
            moreMenu: [{
                id: 'change-broadcast',
                label: "Change broadcast"
            }],
            broadcast_id: null,
            session_id: null,
            token: null,
            error: null,
            connected: false,
            video: false,
            audio: false,
            screenShare: false,
            modal: false,
            inviteSessionModal: false,
            sessionHelper: null,
            elapsed_time: "00:00:00",
            connectionArray: [],
            OTSessionConnection: [],
            signalArray: [],
            subscribedToSignal:false,
            tabActiveIndex: 1,
            clicked_user_details: null,
            currency_symbol: "£",
            total: "0.00",
            private_broadcast_id: -1,
            groupRequest: [],
            oneToOneRequest: [],
            viewerLeftSession: false,
            privateRequestSentToViewer: false,
            userDataOfPrivateRequestSentToViewer: null,
            viewerAcceptedPrivateRequest: false,
            viewer_id: -1,
            is_invite_sent: false,
            commonModalMsg:
                "You cannot send more than one private request, please wait while the viewer accepts/reject your request.",
            togglePubSubState: false,
            isPrivateSession: true,
            isFullScreen: false,
            globalPublisher: null,
            videoSource: null,
            audioSource: null,
            videoSourceIndex: -1,
            audioSourceIndex: 0,
            isTipIconShaking: false,
            tipGoalData: {
                maximum_tip: 0,
                percentage: 0,
                tip_goal_amount: 0,
                tip_goal_amount_formatted: "£ 0.00",
                total_contributors: 0,
                total_tip_amount: 0,
                total_tip_amount_formatted: "£ 0.00"
            },
            availability: false,
            availability_id: -1,
            oneOnOneFirebaseData: {
                created_at: "",
                created_at_human_readable: "",
                from: "viewer",
                id: -1,
                is_favourite: false,
                message: "Call will automatically disconnect if the user doesn’t respond...",
                profile_pic: "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Account-icon%403x.png",
                read: true,
                status: 1,
                title: "Waiting for user to accept call request...",
                updated_at: "",
                updated_at_human_readable: "",
                user_acceptance: "no_action",
                user_id: "",
                username: "",
            },
            countDownToRejectTheRequest: "00:59",
            privateSessionFirebaseData: {},
            broadcasterType: "private",
            activeRightLayout: 'chat',
            notification: {
                'chat': false,
                'onetoone': false,
                'group': false,
                'tip': false,
                'tipgoal': false
            },
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight
        };

        this.sessionEvents = {
            sessionConnected: () => {
                this.setState({connected: true});
                startOTSessionCountdown((time) => {
                    this.setElapsedTime(time)
                })
            },
            sessionDisconnected: () => {
                this.setState({connected: false});
                endOTSessionCountdown();
            },
        };

        //all the functions used in this component should be listed here for better documentation
        this.setOTSession = this.setOTSession.bind(this);
        this.onError = this.onError.bind(this);
        this.disconnectOTSession = this.disconnectOTSession.bind(this);
        this.navigateUserOut = this.navigateUserOut.bind(this);
        this.toggleVideo = this.toggleVideo.bind(this);
        this.toggleAudio = this.toggleAudio.bind(this);
        this.toggleScreenShare = this.toggleScreenShare.bind(this);
        this.togglePubSub = this.togglePubSub.bind(this);
        this.toggleFull = this.toggleFull.bind(this);
        this.requestFullScreen = this.requestFullScreen.bind(this);
        this.toggleEndSessionModal = this.toggleEndSessionModal.bind(this);
        this.toggleInviteForSessionModal = this.toggleInviteForSessionModal.bind(this);
        this.disconnectFromTokBoxAndChangeBroadcast = this.disconnectFromTokBoxAndChangeBroadcast.bind(this);
        this.disconnectFromTokBoxAndChangeBroadcastToPrivate = this.disconnectFromTokBoxAndChangeBroadcastToPrivate.bind(this);
        this.escFunction = this.escFunction.bind(this);

        updateVideoDimensions();
    }

    updateTipGoalProgress = (progress) => {

        let tipGoalProgress = document.getElementById('tip-goal-progress');
        if (tipGoalProgress) {
            document.getElementById('tip-goal-progress').style.display = "block";
        }
        let svgPath = document.getElementById('heart-path');
        if (svgPath) {
            let path = new ProgressBar.Path(svgPath, {
                color: '#FCB03C',
                duration: 3000,
                easing: 'easeInOut'
            });

            path.animate(progress);
        }
    };

    changeAudio = (index) => {
        if (this.publisherRef) {
            let publisher = this.publisherRef.current.getPublisher();
            publisher.setAudioSource(this.state.audioDevices[index]["deviceId"]);
        }
        this.setState({
            audioSource: this.state.audioDevices[index]["deviceId"],
            audioSourceIndex: index,
        });
    };

    changeVideo = (index) => {
        if (this.state.videoDevices.length > 0) {
            this.setState({
                videoSource: this.state.videoDevices[index]["deviceId"],
                videoSourceIndex: index,
            });
        }
    };

    videoDimensions = (video) => {
        try {
            // Ratio of the video's intrinsic dimensions
            let videoRatio = video.videoWidth / video.videoHeight;
            // The width and height of the video element
            let width = video.offsetWidth,
                height = video.offsetHeight;
            // The ratio of the element's width to its height
            let elementRatio = width / height;

            return {
                width: width,
                height: height,
            };
            // If the video element is short and wide
            //if (elementRatio > videoRatio) width = height * videoRatio;
            // It must be tall and thin, or exactly equal to the original ratio
            //else height = width / videoRatio;
        } catch (e) {
        }
    };

    setVideoCloseFrame = () => {
        let parent = document.getElementsByClassName("OT_widget-container")[0],
            video = document.getElementsByClassName("OT_video-element")[0],
            frame = document.createElement("div");

        if (!video) {
            return;
        }

        let dimension = this.videoDimensions(video);
        let frameDimension = {
            //width: (dimension.height * 9) / 16,
            width:
            (document.getElementsByClassName("video-container")[0].offsetHeight *
                9) /
            16,
            height: dimension.height,
            left: 0,
        };

        //frameDimension.left = (dimension.width - frameDimension.width) / 2
        frameDimension.left =
            (document.getElementsByClassName("video-container")[0].offsetWidth -
                frameDimension.width) /
            2;

        if (document.getElementById("OT_video-element-frame")) {
            document.getElementById("OT_video-element-frame").remove();
        }

        frame.setAttribute("id", "OT_video-element-frame");
        frame.style.cssText =
            "position: absolute;" +
            "top: 0;" +
            "left: " +
            frameDimension.left +
            "px;" +
            "z-index: 1;" +
            "width: " +
            frameDimension.width +
            "px;" +
            //"height: " + frameDimension.height + "px;" +
            "height: " +
            document.getElementsByClassName("video-container")[0].offsetHeight +
            "px;" +
            "border:2px dashed #1B75BC;";

        let img = document.createElement("img");
        img.style.cssText = "position: absolute;top: 0px;left: -16px;";
        img.src = cross;
        img.onclick = function () {
            document.getElementById("OT_video-element-frame").style.display = "none";
        };

        frame.appendChild(img);
        parent.appendChild(frame);
    };

    checkValidBroadcast() {
        //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
        checkValidBroadcast(this.props.location)
            .then((broadcastDetail) => {
                this.setState({
                        broadcast_id: decodeEncryptedIdForBroadcaster(
                            broadcastDetail.broadcast_id
                        ),
                        private_broadcast_id: broadcastDetail.hasOwnProperty(
                            "private_broadcast_id"
                        )
                            ? decodeEncryptedIdForBroadcaster(
                                broadcastDetail.private_broadcast_id
                            )
                            : -1,
                        session_id: broadcastDetail.session_id,
                        token: broadcastDetail.token,
                        availability: broadcastDetail.hasOwnProperty("availability"),
                        availability_id: broadcastDetail.hasOwnProperty("availability") ? decodeEncryptedIdForBroadcaster(broadcastDetail.availability_id) : -1,
                    },
                    () => {
                        if (this.state.broadcast_id === -1) {
                            //TODO
                            //there is some URL manipulation done show error and navigate the user out of this screen
                            this.props.history.push("/broadcaster/create/broadcast");
                        } else {
                            /**
                             * @Webservice GET Broadcast detail API
                             */
                            getData(LOGIN).then((data) => {
                                if (!isEmpty(data)) {
                                    const broadcastId = this.state.broadcast_id;

                                    this.props.getBroadcastDetail(
                                        data.token,
                                        data.api_token,
                                        broadcastId
                                    );
                                }
                            });

                            // setTimeout(()=>{
                            //     testConnectivity(broadcastDetail.session_id,broadcastDetail.token)
                            // },5000);

                            /**
                             * @listens Firebase listener for the private sessions
                             * only listen if the video flow is from availability
                             */
                            if (this.state.availability) {
                                subscribeToPrivateFireStore(
                                    this.state.broadcast_id.toString(),
                                    this.privateSessionUpdate
                                )
                            }
                        }

                        if (this.state.private_broadcast_id === -1) {
                            try {
                                OT.getDevices((error, devices) => {
                                    if (error) {
                                        return;
                                    }
                                    const audioDeviceIds = devices.filter((e) => e.kind == "audioInput");
                                    const videoDeviceIds = devices.filter((e) => e.kind == "videoInput");

                                    this.setState({
                                        videoDevices: videoDeviceIds,
                                        audioDevices: audioDeviceIds,
                                    });
                                });
                            } catch (e) {
                                LogException("start_broadcast", "componentDidMount", e);
                            }
                        }else{
                            try {
                                OT.getDevices((error, devices) => {
                                    if (error) {
                                        return;
                                    }
                                    const videoDeviceIds = devices.filter((e) => e.kind == "videoInput");

                                    this.setState({
                                        videoDevices: videoDeviceIds,
                                    });
                                });
                            } catch (e) {
                                LogException("start_broadcast", "componentDidMount", e);
                            }
                        }
                    }
                );
            })
            .catch((err) => {
                this.props.showLeftBar(); //show the leftbar
                LogException("StartBroadcast", "checkValidBroadcast", err);
                this.navigateUserOut(
                    "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later."
                );
            });
    }

    privateSessionUpdate = (querySnapshot) => {
        let privateRequest = [];
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            privateRequest.push(data);

            if (this.state.private_broadcast_id !== null && parseInt(data.id) === parseInt(this.state.private_broadcast_id)) {
                this.setState({
                    privateSessionFirebaseData: data
                })
                subscribeToFireStoreForOneToOneRequest(
                    this.state.broadcast_id,
                    data.viewer_id,
                    this.onOneToOneRequestUpdateForViewer
                );
            }
        });

    };


    timeoutForRequestAcceptance(title, message, callTimeoutAPI) {
        if (callTimeoutAPI) {
            let requestID = this.state.oneOnOneFirebaseData.id;
            if (requestID !== -1) {
                getData(LOGIN).then((data) => {
                    if (!isEmpty(data)) {

                        this.props.broadcasterTimeoutRequest(
                            data.token,
                            data.api_token,
                            requestID,
                            this.state.broadcast.id.toString()
                        );
                    }
                });
            }
        }


        this.setState({
            oneOnOneFirebaseData: {
                created_at: "",
                created_at_human_readable: "",
                from: "viewer",
                id: -1,
                is_favourite: false,
                message: message,
                profile_pic: "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Account-icon%403x.png",
                read: true,
                status: 1,
                title: title,
                updated_at: "",
                updated_at_human_readable: "",
                user_acceptance: "no_action",
                user_id: "",
                username: "",
            }
        });
    }

    updateBroadcasterType = (broadcasterType) => {
        this.setState({
            broadcasterType
        })
    };

    onOneToOneRequestUpdateForViewer = (documentSnapshot) => {

        if (documentSnapshot.exists) {

            const requestData = documentSnapshot.data();

            this.setState({
                oneOnOneFirebaseData: requestData
            }, () => {
                //logic here
                switch (this.state.oneOnOneFirebaseData.user_acceptance) {
                    case "no_action":
                        //Wait for wait_time_in_seconds and if the user_acceptance change then take action accordingly else timeout API
                        let wait_time_in_seconds = this.state.privateSessionFirebaseData.hasOwnProperty("wait_time_in_seconds") ? parseInt(this.state.privateSessionFirebaseData.wait_time_in_seconds) : 30;
                        startCountdownFunc(wait_time_in_seconds, (timeLeft, timeLeftFormatted) => {
                            //callback

                            if (this.state.connectionArray.length > 0) {
                                endCountdownFunc()
                            } else {
                                this.setState({
                                    countDownToRejectTheRequest: timeLeftFormatted
                                }, () => {
                                    if (timeLeft < 0) {
                                        this.timeoutForRequestAcceptance("Timeout", "Sorry, seems like the user couldn't make it to the session. Please invite others", true);
                                    }
                                })
                            }

                        });
                        break;
                    case "accepted":
                        //As a developer if we get accepted then this means user is about to about to join
                        break;
                    case "declined":
                        //As a developer if we get declined then open bottom sheet skip timeout API
                        endCountdownFunc();
                        break;
                    case "timeout":
                        //As a developer if we get timeout then open bottom sheet skip timeout API
                        endCountdownFunc();
                        break;
                }
            })
        }
    };

    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        this.checkValidBroadcast();

        this.props.hideLeftBar(); //hide the leftbar
        this.props.hideSearchBar(); //hide the Search bar

        document.addEventListener("fullscreenchange", this.escFunction);
        document.addEventListener("webkitfullscreenchange", this.escFunction);
        document.addEventListener("mozfullscreenchange", this.escFunction);
        document.addEventListener("MSFullscreenChange", this.escFunction);

        window.addEventListener('resize', () => {

            this.setState({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
            }, () => {
                updateVideoDimensions();
            })
        })
    }



    /**
     * @function This method is called when a component is being removed from the DOM
     * so we have to unsubscribe to all events & disconnect from OT Session
     */
    componentWillUnmount() {
        this.disconnectOTSession();
        unsubscribeToFireStore(this.state.broadcast_id);
        this.props.showSearchBar(); //Show the Search bar
        document.addEventListener("fullscreenchange", this.escFunction);
        document.addEventListener("webkitfullscreenchange", this.escFunction);
        document.addEventListener("mozfullscreenchange", this.escFunction);
        document.addEventListener("MSFullscreenChange", this.escFunction);
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        //tip goal response received
        if (nextProps.tip !== null &&
            nextProps.tip.hasOwnProperty("tipGoalDataList") &&
            nextProps.tip.tipGoalDataList !== null &&
            nextProps.tip.tipGoalDataList.hasOwnProperty("data") &&
            nextProps.tip.tipGoalDataList.data.hasOwnProperty("tips")
        ) {
            const tip = nextProps.tip;
            this.props.resetTipDataListForTipGoal();

            this.setState({
                tip
            });
        }

        //broadcaster get details
        if (nextProps.broadcaster_detail_management && nextProps.broadcaster_detail_management.broadcastDetail != null) {
            if (nextProps.broadcaster_detail_management.broadcastDetail.hasOwnProperty("data") &&
                nextProps.broadcaster_detail_management.broadcastDetail.data.length > 0) {

                this.setState({
                        broadcast: nextProps.broadcaster_detail_management.broadcastDetail.data[0]
                    }, () => {

                        //Tip goal regarding data from store
                        if (this.state.broadcast.hasOwnProperty("tip_goal") &&
                            Array.isArray(this.state.broadcast.tip_goal) &&
                            this.state.broadcast.tip_goal.length > 0) {

                            this.setState({
                                tipGoalPurpose: this.state.broadcast.tip_goal[0].purpose,
                            });
                            this.setState({
                                tipGoalId: this.state.broadcast.tip_goal[0].id,
                            });

                            /**
                             * @business_rule
                             * listener for tip_goal
                             */
                            subscribeToFireStoreForTipGoal(
                                this.state.broadcast.id.toString(),
                                this.state.broadcast.tip_goal[0].tip_goal_id,
                                this.onRequestTipGoalData
                            );
                        }

                    /**
                     * @business_rule
                     * listener for group & one to one request
                     */
                    subscribeToFireStore(
                        this.state.broadcast.id.toString(),
                        this.onGroupRequestUpdate,
                        this.onOneToOneRequestUpdate
                    );

                    if (this.state.broadcast.hasOwnProperty("broadcast_end_at") && this.state.broadcast.broadcast_end_at !== null) {

                        if (this.state.broadcast.private.hasOwnProperty("end_at") && this.state.broadcast.private.end_at !== null) {
                            if (this.state.private_session_id !== -1) {
                                vuepayAlert("error", "Private session has ended!", () => {
                                    navigate(this.props, "broadcaster_create_broadcast");
                                });
                            }
                        }

                        return;
                    }

                        if (Array.isArray(this.state.broadcast.private)) {
                            createBroadcastOnFirestore(
                                this.state.broadcast_id,
                                {
                                    broadcast_type: this.state.broadcast.broadcast_type,
                                    group_session_price: this.state.broadcast.group_session_price,
                                    one_to_one_session_allow: this.state.broadcast
                                        .one_to_one_session_allow,
                                    one_to_one_session_price: this.state.broadcast
                                        .one_to_one_session_price,
                                    session_description: this.state.broadcast.session_description,
                                    session_title: this.state.broadcast.session_title,
                                },
                                () => {
                                    /**
                                     * @business_rule
                                     * listener for group & one to one request
                                     */

                                    subscribeToFireStore(
                                        this.state.broadcast_id,
                                        this.onGroupRequestUpdate,
                                        this.onOneToOneRequestUpdate
                                    );
                                }
                            );
                        }
                    }
                );
            } else if (
                nextProps.broadcaster_detail_management.broadcastDetail.error != null
            ) {
                //get the user out of this screen
                this.navigateUserOut(
                    nextProps.broadcaster_detail_management.broadcastDetail.error.message
                );
            }

            this.props.resetBroadcastDetail();
        }

        //broadcaster earnings
        if (
            nextProps.get_broadcast_earnings !== null &&
            nextProps.get_broadcast_earnings.hasOwnProperty("payload") &&
            nextProps.get_broadcast_earnings.payload !== null
        ) {
            const payload = nextProps.get_broadcast_earnings.payload;
            this.props.resetGetBroacastEarnings();

            //if the status_code received from the server is 200 means the user has successfully done the forgot password
            if (payload.status_code === 200) {
                //update the user earnings
                this.setState({
                    currency_symbol: payload.currency_symbol,
                    total: payload.total,
                });
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                vuepayAlert("error", payload.message);
            }
        }

        //check Favourite
        if (
            nextProps.hasOwnProperty("broadcaster_favourites") &&
            nextProps.broadcaster_favourites.hasOwnProperty(
                "favourite_unfavourite_data"
            ) &&
            nextProps.broadcaster_favourites.favourite_unfavourite_data != null &&
            nextProps.broadcaster_favourites.favourite_unfavourite_data.hasOwnProperty(
                "success"
            ) &&
            !nextProps.broadcaster_favourites.isFetching &&
            nextProps.broadcaster_favourites.isSuccess
        ) {
            let index = _.findIndex(this.state.connectionArray, {
                id: this.state.clicked_user_details.id,
            });

            const connectionArray = this.state.connectionArray;
            if (connectionArray[index].userData.is_favorite === "false") {
                connectionArray[index].userData.is_favorite = "true";
            } else {
                connectionArray[index].userData.is_favorite = "false";
            }
            this.setState(
                {
                    connectionArray: connectionArray,
                    clicked_user_details: connectionArray[index],
                },
                () => {
                    this.toggleInviteForSessionModal();
                }
            );

            this.props.resetFavouritesUnFavouriteData();
        }

        //check Blocked status
        if (
            nextProps.hasOwnProperty("broadcaster_block_unblock_viewer") &&
            nextProps.broadcaster_block_unblock_viewer.hasOwnProperty("payload") &&
            nextProps.broadcaster_block_unblock_viewer.payload != null &&
            nextProps.broadcaster_block_unblock_viewer.payload.hasOwnProperty(
                "success"
            ) &&
            !nextProps.broadcaster_block_unblock_viewer.isFetching &&
            nextProps.broadcaster_block_unblock_viewer.payload.isSuccess
        ) {
            let index = _.findIndex(this.state.connectionArray, {
                id: this.state.clicked_user_details.id,
            });

            const connectionArray = this.state.connectionArray;
            if (connectionArray[index].userData.hasOwnProperty("is_blocked")) {
                if (connectionArray[index].userData.is_blocked === "false") {
                    connectionArray[index].userData.is_blocked = "true";
                } else {
                    connectionArray[index].userData.is_blocked = "false";
                }
            } else {
                connectionArray[index].userData.is_blocked = "true";
            }

            this.setState(
                {
                    connectionArray: connectionArray,
                    clicked_user_details: connectionArray[index],
                },
                () => {
                    this.toggleInviteForSessionModal();
                }
            );

            this.props.resetBlockUnBlockData();
        }

        /**
         * if a broadcaster has accepted a private request invite then this is called
         */
        if (checkIfCreatePrivateBroadcast(nextProps)) {
            if (nextProps.broadcast.private_broadcast_payload.status_code === 201) {
                const payload = nextProps.broadcast.private_broadcast_payload;
                //if the status_code received from the server is 201 means the broadcast was created successfully
                nextProps.resetPrivateBroadcast();
                updateJWTToken(payload, () => {
                    // add paid group node in firestore
                    if (this.state.viewerAcceptedPrivateRequest) {
                        createPrivateSessionRecord(
                            this.state.broadcast.id.toString(),
                            payload.data.id.toString(),
                            this.state.viewer_id.toString(),
                            () => {
                                this.disconnectFromTokBoxAndChangeBroadcastToPrivate(
                                    payload.data
                                );
                            }
                        );
                    } else {
                        updatePrivateSessionRequestStatus(
                            this.state.broadcast.id.toString(),
                            this.state.viewer_id.toString(),
                            1,
                            () => {
                                createPrivateSessionRecord(
                                    this.state.broadcast.id.toString(),
                                    payload.data.id.toString(),
                                    this.state.viewer_id.toString(),
                                    () => {
                                        this.disconnectFromTokBoxAndChangeBroadcastToPrivate(
                                            payload.data
                                        );
                                    }
                                );
                            }
                        );
                    }
                });

                vuepayAlert("success", payload.message);
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                nextProps.resetPrivateBroadcast();
                nextProps.resetUpdateBroadcast();
                vuepayAlert("error", nextProps.broadcast.payload.message);
            }
        }
    }

    onRequestTipGoalData = (querySnapshot) => {
        if (querySnapshot.exists) {
            this.setState({
                tipGoalData: querySnapshot.data(),
            });

            if (this.state.tipGoalData.hasOwnProperty("percentage") && this.state.tipGoalData.percentage !== null) {
                //reset the progress to zero
                let progress = (this.state.tipGoalData.percentage / 100) > 1 ? 1 : this.state.tipGoalData.percentage / 100;
                this.updateTipGoalProgress(progress);
                if (this.state.tipGoalData.percentage > 0) {
                    this.updateNotification("tipgoal", true)
                }
            }

            if (this.state.activeRightLayout === "tipgoal") {
                getData(LOGIN).then((data) => {

                    if (!isEmpty(data)) {
                        this.props.getTipDataListForTipGoal(
                            data.token,
                            data.api_token,
                            this.state.broadcast.id.toString(),
                            this.state.broadcast.tip_goal[0].id
                        );
                    }
                });
            }
        }
    };

    updateNotification = (forKey, value) => {
        let notification = this.state.notification;
        if (this.state.activeRightLayout !== forKey) {
            notification[forKey] = true;
            let notificationSound= document.getElementById("notification-sound");
            if(notificationSound){
                notificationSound.play();
            }
        } else {
            notification[forKey] = false;
        }

        this.setState({
            notification
        });
    };

    onGroupRequestUpdate = (querySnapshot) => {
        vuePayLog(screename, "onGroupRequestUpdate");
        let groupRequest = [];
        querySnapshot.forEach((doc) => {
            if (doc.exists && doc.data().status === 0) {
                groupRequest.push(doc.data());
            }
        });

        this.setState({
            groupRequest: groupRequest,
        }, () => {
            this.props.updateGroupAvailabilityList(groupRequest);
            if (groupRequest.length > 0) {
                this.updateNotification("group", true)
            }
        });
    };

    onOneToOneRequestUpdate = (querySnapshot) => {
        vuePayLog(screename, "onOneToOneRequestUpdate");
        let oneToOneRequest = [];
        querySnapshot.forEach((doc) => {
            if (this.state.availability) {
                if (doc.exists && doc.data().status === 0) {
                    oneToOneRequest.push({...doc.data(), id: doc.id, request_id: doc.data().id});
                }
            } else {
                if (doc.exists && doc.data().status === 0) {
                    oneToOneRequest.push({...doc.data(), id: doc.id, request_id: doc.data().id});
                }
            }

            if (this.state.private_broadcast_id === -1) {
                if (doc.exists && doc.data().from === "broadcaster" && doc.data().status === 1) {
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {
                            const jsonData = {
                                device: this.props.device,
                                broadcast_id: this.state.broadcast_id,
                            };
                            this.setState(
                                {
                                    viewerAcceptedPrivateRequest: true,
                                    viewer_id: doc.id,
                                },
                                () => {
                                    this.props.createPrivateBroadcast(
                                        data.token,
                                        data.api_token,
                                        jsonData
                                    );
                                }
                            );
                        }
                    });
                }
            }
        });

        this.setState({
            oneToOneRequest: oneToOneRequest,
        }, () => {
            this.props.updateOneToOneAvailabilityList(oneToOneRequest);
            if (oneToOneRequest.length > 0) {
                this.updateNotification("onetoone", true)
            }
        });
    };

    navigateUserOut = (message) => {
        vuepayAlert("error", message, () => {
            navigate(this.props, "broadcaster_create_broadcast");
        });
    };

    disconnectOTSession = () => {
        if (this.otSession && this.otSession.current !== null) {
            this.otSession.current.sessionHelper.session.disconnect();
        }
    };

    disconnectOTSessionAndNavigateToHomeScreen = () => {
        if (this.otSession && this.otSession.current !== null) {
            this.otSession.current.sessionHelper.session.disconnect();
            removeAllModalPopUps();
            getData(USER_DATA).then((data) => {
                if (!isEmpty(data)) {
                    makeUserOnline(data.user_id);
                }
            });
            navigate(this.props, "broadcaster_create_broadcast");
            window.location.reload();
        }
    };

    onError = (err) => {
        this.setState({error: `Failed to connect: ${err.message}`});
    };

    setOTSession = (session) => {
        this.setState({
            sessionHelper: session,
        });

        this.otSession.current.sessionHelper.session.on(
            "sessionDisconnected",
            (event) => {

                if (
                    event.hasOwnProperty("reason") &&
                    event.reason === "forceDisconnected"
                ) {
                    this.disconnectOTSession();
                    vuepayAlert(
                        "error",
                        "Your session has been ended by VuePay, as viewers have reported against this broadcast."
                    );
                    navigate(this.props, "broadcaster_create_broadcast");
                }
            }
        );

        this.otSession.current.sessionHelper.session.on(
            "connectionCreated",
            (event) => {
                //a publisher is a part of connection so lets avoid his VIEW count
                if (this.otSession.current.sessionHelper.session.connection.connectionId !== event.connection.connectionId) {
                    let connectionArray = this.state.connectionArray,
                        OTSessionConnection = this.state.OTSessionConnection;
                    const connection = getConnectionObject(event);

                    const found = connectionArray.find(
                        (element) => element.connectionId === connection.connectionId
                    );
                    if (!found) {
                        connectionArray.push(connection);
                    }

                    //this OTSessionConnectionArray is used only of the broadcaster request to block a user
                    OTSessionConnection[connection.userData.user_api_id] = event.connection;

                    this.setState({
                        connectionArray: connectionArray,
                        OTSessionConnection: OTSessionConnection,
                    });
                }

                if(!this.state.subscribedToSignal){
                    this.setState({
                        subscribedToSignal: true
                    },()=>{
                        this.otSession.current.sessionHelper.session.on("signal", (event) => {
                            let signalArray = this.state.signalArray;
                            const signal = getSignalObject(event);

                            // const found = signalArray.find(
                            //     (element) =>
                            //         element.connectionId === signal.connectionId &&
                            //         element.text === signal.text
                            // );

                            // if (!found) {
                            signalArray.push(signal);
                            this.setState({
                                signalArray: signalArray,
                            }, () => {
                                const elmnt = document.getElementById("divElem");
                                if (elmnt) {
                                    elmnt.scrollTop = elmnt.scrollHeight + 36;
                                }
                                this.updateNotification("chat", true)
                            });
                            // }

                            /**
                             * @business
                             * If the user is tipping then we have to do a shake animation
                             * check if signal.type === signal:VuePay-tipping this means a user has tipped
                             */
                            if (signal.type === "signal:VuePay-tipping") {
                                this.updateNotification("tip", true)
                            }
                        });
                    });
                }
            }
        );

        this.otSession.current.sessionHelper.session.on(
            "connectionDestroyed",
            (event) => {

                if (event.reason === "clientDisconnected") {
                    if (this.state.private_broadcast_id !== -1) {
                        if (this.state.availability) {
                            endCountdownFunc();
                            this.timeoutForRequestAcceptance("User left the session", "Sorry, seems like the user has left the session. Please invite others", false);
                        } else {
                            this.setState({viewerLeftSession: true},
                                () => {
                                    // this.toggleEndSessionModal()  // commented this method because connectionDestroyed event firing two times which hide leave session modal
                                    // implemented below code to stop toggling over two times firing connectionDestroyed
                                    //const modal = document.getElementById("end-broadcast-session");
                                    //showModal(modal);
                                    vuepayAlert("success", "Your session has been ended as viewer left the session");
                                    this.disconnectOTSession();
                                }
                            );
                        }
                    }
                }

                let connectionArray = this.state.connectionArray;
                connectionArray = removeConnectionObject(event, connectionArray);
                this.setState({
                    connectionArray: connectionArray,
                });
            }
        );


        if (this.state.private_broadcast_id === -1) {
            this.setVideoCloseFrame();
        }

        let ref = this;
        window.addEventListener("resize", function (e) {
            if (ref.state.private_broadcast_id === -1) {
                ref.setVideoCloseFrame();
            }
        });
    };

    setElapsedTime = (time) => {
        this.setState({
                elapsed_time: time,
            },
            () => {
                /**
                 * @business_rule
                 * check if the seconds count is 59 then
                 */
                const timeArray = time.split(":"),
                    seconds = timeArray[2];//the seconds section

                if (parseInt(seconds) % 59 === 0) {
                    /**
                     * @Webservice GET earnings for a private or group broadcast
                     */
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {
                            if (this.state.private_broadcast_id === -1) {

                                if (this.state.broadcast && this.state.broadcast.broadcast_type === "paid") {
                                    this.props.getBroacastEarnings(
                                        data.token,
                                        data.api_token,
                                        "group",
                                        this.state.broadcast.id
                                    );
                                }
                            } else {
                                this.props.getBroacastEarnings(
                                    data.token,
                                    data.api_token,
                                    "private",
                                    this.state.private_broadcast_id
                                );
                            }
                        }
                    });
                }
                // }
            }
        );
    };

    setUserData = (connection) => {
        let index = _.findIndex(this.state.connectionArray, {id: connection.id});
        this.setState(
            {
                clicked_user_details: this.state.connectionArray[index],
            },
            () => {
                if (
                    this.state.clicked_user_details !== undefined &&
                    this.state.clicked_user_details !== null &&
                    this.state.clicked_user_details.hasOwnProperty("userData") &&
                    this.state.clicked_user_details.userData.hasOwnProperty("user_api_id")
                ) {
                    const user_api_id = this.state.clicked_user_details.userData
                        .user_api_id;
                    const index = _.findIndex(this.state.oneToOneRequest, function (o) {
                        return o.id === user_api_id;
                    });
                    if (index >= 0) {
                        this.setState({
                            is_invite_sent:
                            this.state.oneToOneRequest[index].from === "broadcaster",
                        });
                    }
                }
            }
        );
    };

    toggleVideo() {
        this.setState({
            video: !this.state.video,
        });
    }

    toggleAudio() {
        this.setState({
            audio: !this.state.audio,
        });
    }

    toggleScreenShare() {
        if (this.state.screenShare) {
            //user is already sharing the screen
            this.changeVideo(0);
            this.setState({
                audioSource: null,
                screenShare: false,
            });
        } else {
            let ref = this;
            OT.checkScreenSharingCapability(function (response) {
                if (!response.supported || response.extensionRegistered === false) {
                    // This browser does not support screen sharing
                    //console.log("This browser does not support screen sharing")
                } else if (response.extensionInstalled === false) {
                    // Prompt to install the extension
                    //console.log("Prompt to install the extension")
                } else {
                    // Screen sharing is available.
                    //console.log("Screen sharing is available.")
                    // ref.setState({
                    //     screenShare: !ref.state.screenShare
                    // });

                    Promise.all([
                        OT.getUserMedia({
                            videoSource: "screen",
                        }),
                        OT.getUserMedia({
                            videoSource: null,
                        }),
                    ]).then(([screenStream, micStream]) => {
                        // return OT.initPublisher(null, {
                        //     videoSource: screenStream.getVideoTracks()[0],
                        //     audioSource: micStream.getAudioTracks()[0]
                        // });

                        if (
                            screenStream !== null &&
                            Array.isArray(screenStream.getVideoTracks())
                        ) {
                            if (
                                micStream !== null &&
                                Array.isArray(micStream.getAudioTracks())
                            ) {
                                ref.setState({
                                    videoSource: screenStream.getVideoTracks()[0],
                                    audioSource: micStream.getAudioTracks()[0],
                                    screenShare: true,
                                });
                            } else {
                                alert("Couldn't get your audio track");
                            }
                        } else {
                            alert("Couldn't get your video track");
                        }
                    });
                }
            });
        }
    }

    toggleEndSessionModal = () => {
        const modal = document.getElementById("end-broadcast-session");
        this.setState(
            {
                modal: !this.state.modal,
            },
            () => {
                this.state.modal ? showModal(modal) : hideModal(modal);
            }
        );
    };

    toggleCommonModal = () => {
        const modal = document.getElementById("common-modal");
        this.setState(
            {
                modal: !this.state.modal,
            },
            () => {
                this.state.modal ? showModal(modal) : hideModal(modal);
            }
        );
    };

    toggleInviteForSessionModal = () => {
        setTimeout(() => {
            const modal = document.getElementById("invite-for-session");
            this.setState(
                {
                    inviteSessionModal: !this.state.inviteSessionModal,
                },
                () => {
                    this.state.inviteSessionModal ? showModal(modal) : hideModal(modal);
                }
            );
        }, 200); //delay for the modal to come into memory
    };

    requestFullScreen = () => {
        //const video = document.getElementsByClassName("OT_video-element")[0];
        // const video = document.getElementsByClassName("OT_video-element")[
        //     (document.getElementsByClassName("OT_video-element").length > 1) ?
        //         1 : 0
        //     ];
        const video = document.getElementsByClassName("video-container")[0];
        this.setState({isFullScreen: true}, () => {
            requestFullScreen(video);
            document.getElementsByClassName("video-container")[0].style.width =
                "100%";
            setTimeout(() => {
                this.toggleFull();
                if (document.getElementById("OT_video-element-frame")) {
                    document.getElementById("OT_video-element-frame").style.zIndex =
                        "-10";
                }
            }, 1000);
        });
    };

    escFunction = (event) => {
        if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
        ) {
            this.setState({isFullScreen: false}, () => {
                setTimeout(() => {
                    this.toggleFull();
                    if (document.getElementById("OT_video-element-frame")) {
                        document.getElementById("OT_video-element-frame").style.zIndex =
                            "1";
                    }
                }, 1000);
            });
        }
    };

    setTabActiveIndex = (index) => {
        this.setState({
            tabActiveIndex: index,
        });
    };

    createBroadcast = (token, api_token, formData) => {
        this.props.createBroadcast(token, api_token, formData);
    };

    disconnectFromTokBoxAndChangeBroadcast = (data) => {
        const waitForDisconnect = 500; //0.5 secs
        this.disconnectOTSession();
        setTimeout(() => {
            //create broadcast
            const broadcastID = getEncryptedIdForBroadcaster(data.id);
            removeAllModalPopUps();
            let path = `/broadcaster/start/broadcast?session_id=${data.session_id}&broadcast_id=${broadcastID}&token=${data.token}`;

            if (this.state.availability) {
                path = `/broadcaster/start/broadcast?session_id=${data.session_id}&broadcast_id=${broadcastID}&token=${data.token}&availability=true&availability_id=${getEncryptedIdForBroadcaster(this.state.availability_id)}`;
            }
            this.props.history.push(path, {
                session_id: data.session_id,
                broadcast_id: data.id,
                token: data.token,
            });

            window.location.href = path;

        }, waitForDisconnect);
    };

    setInteractedViewerID = (viewer_id) => {
        this.setState({
            viewer_id: viewer_id,
        });
    };

    disconnectFromTokBoxAndChangeBroadcastToPrivate = (data) => {
        const waitForDisconnect = 500; //0.5 secs
        this.disconnectOTSession();
        setTimeout(() => {
            //create broadcast
            const broadcastID = getEncryptedIdForBroadcaster(this.state.broadcast_id);
            const private_broadcast_id = getEncryptedIdForBroadcaster(data.id);

            removeAllModalPopUps();

            let path = `/broadcaster/start/broadcast?session_id=${data.session_id}&broadcast_id=${broadcastID}&token=${data.token}&private_broadcast_id=${private_broadcast_id}`;

            if (this.state.availability) {
                path = `/broadcaster/start/broadcast?session_id=${data.session_id}&broadcast_id=${broadcastID}&token=${data.token}&private_broadcast_id=${private_broadcast_id}&availability=true&availability_id=${getEncryptedIdForBroadcaster(this.state.availability_id)}`;
            }
            this.props.history.push(path, {
                session_id: data.session_id,
                broadcast_id: data.id,
                token: data.token,
            });

            window.location.href = path;
        }, waitForDisconnect);
    };

    favouriteUnFavouriteUser = () => {
        if (this.state.clicked_user_details) {
            const user = this.state.clicked_user_details.userData;
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    if (user.is_favorite === "true") {
                        this.props.unFavouriteViewer(
                            data.token,
                            data.api_token,
                            user.user_api_id
                        );
                    } else {
                        this.props.favouriteViewer(
                            data.token,
                            data.api_token,
                            user.user_api_id
                        );
                    }
                }
            });
        }
    };

    blockOnUnblockViewer = () => {
        if (this.state.clicked_user_details) {
            const user = this.state.clicked_user_details.userData;
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    if (user.hasOwnProperty("is_blocked")) {
                        if (user.is_blocked === "true") {
                            this.props.unBlockViewer(
                                data.token,
                                data.api_token,
                                user.user_api_id
                            );
                        } else {
                            this.props.blockViewer(
                                data.token,
                                data.api_token,
                                user.user_api_id
                            );
                        }
                    } else {
                        this.props.blockViewer(
                            data.token,
                            data.api_token,
                            user.user_api_id
                        );
                    }
                }
            });

            if (
                this.otSession.current.sessionHelper.session.capabilities
                    .forceDisconnect == 1
            ) {
                // The client can forceDisconnect. See the next section.
                ////console.log("The client can forceDisconnect.");
                this.otSession.current.sessionHelper.session.forceDisconnect(
                    this.state.OTSessionConnection[user.user_api_id]
                );
                if (
                    !isEmpty(this.state.clicked_user_details.userData.private_session_id)
                ) {
                    //disconnect the entire session if session is private
                    this.disconnectOTSessionAndNavigateToHomeScreen();
                    //navigate(this.props,"broadcaster_create_broadcast");
                }
            } else {
                // The client cannot moderate.
                ////console.log("The client cannot moderate.");
            }
        }
    };

    /**
     * @function is invoked immediately When Publisher is unable to publish due to any reason
     */
    onPublishError = (e) => {
        vuePayLog("StartBroadcast", "onError", e);
        if (e.hasOwnProperty("message")) {
            // vuepayAlert("error", e.message, () => {
            //     this.disconnectOTSessionAndNavigateToHomeScreen();
            //     navigate(this.props, "broadcaster_create_broadcast");
            // })

            this.props.showCommonModal({
                image: assets.leaving_the_broadcast,
                title: "Video error",
                description: e.message,
                action: {
                    text: "Leave session",
                    click: () => {
                        this.disconnectOTSessionAndNavigateToHomeScreen();
                        navigate(this.props, "broadcaster_create_broadcast");
                    }
                }
            });
        }
    };

    calculateVideoDimensions = () => {
        if (!this.state.togglePubSubState) {
            let chat_window = document.getElementById("chat-window");
            let sub_id = document.getElementById("sub-id");
            sub_id.className = "chat-window";
            document.getElementsByClassName("OTSubscriberContainer")[0].style.height = "150px";
            chat_window.className = "";
            // document.getElementsByClassName(
            //     "OTPublisherContainer"
            // )[0].style.height = `${
            //     document.getElementsByClassName("video-container")[0].offsetHeight
            // }px`;
            updateVideoDimensions();
            this.setState({isPrivateSession: false});
        } else {
            let chat_window = document.getElementById("chat-window");
            let sub_id = document.getElementById("sub-id");
            sub_id.className = "";
            document.getElementsByClassName(
                "OTSubscriberContainer"
            )[0].style.height = `${
                document.getElementsByClassName("video-container")[0].offsetHeight
            }px`;
            chat_window.className = "chat-window";
            document.getElementsByClassName("OTPublisherContainer")[0].style.height =
                "150px";

            this.setState({isPrivateSession: true});
        }
    }

    togglePubSub = () => {
        this.setState({togglePubSubState: !this.state.togglePubSubState});
        this.calculateVideoDimensions();
    };

    toggleFull = () => {
        //console.log("toggleFull togglePubSubState", this.state.togglePubSubState);
        if (this.state.togglePubSubState) {
            if (this.state.private_broadcast_id !== -1) {
                let chat_window = document.getElementById("chat-window");
                let sub_id = document.getElementById("sub-id");
                sub_id.className = "chat-window";
                document.getElementsByClassName(
                    "OTSubscriberContainer"
                )[0].style.height = "150px";
                chat_window.className = "";
                // document.getElementsByClassName(
                //     "OTPublisherContainer"
                // )[0].style.height = `${
                //     document.getElementsByClassName("video-container")[0].offsetHeight
                //     }px`;
                updateVideoDimensions();
                this.setState({isPrivateSession: false});
            }
        } else {
            if (this.state.private_broadcast_id !== -1) {
                let chat_window = document.getElementById("chat-window");
                let sub_id = document.getElementById("sub-id");
                sub_id.className = "";
                document.getElementsByClassName(
                    "OTSubscriberContainer"
                )[0].style.height = `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                    }px`;
                chat_window.className = "chat-window";
                document.getElementsByClassName(
                    "OTPublisherContainer"
                )[0].style.height = "150px";

                this.setState({isPrivateSession: true});
            }
        }
    };

    whenPrivateSession = () => {
        const subscriber = (
            <div id="chat-window" className="chat-window">
                <OTSession
                    ref={this.otSession}
                    apiKey={this.state.api_key}
                    sessionId={this.state.session_id}
                    token={this.state.token}
                    eventHandlers={this.sessionEvents}
                    onError={this.onError}
                >
                    {this.showPublisher("private")}
                </OTSession>
            </div>
        );

        return subscriber;
    };

    showPublisherSubscriberSession = (isSubscribe = null) => {
        const session = (
            <OTSession
                ref={this.otSession}
                apiKey={this.state.api_key}
                sessionId={this.state.session_id}
                token={this.state.token}
                eventHandlers={this.sessionEvents}
                onError={this.onError}
            >
                {isSubscribe ? this.showSubscriber("private") : this.showPublisher()}
            </OTSession>
        );
        return session;
    };

    showPublisher = (isPrivate = null) => {
        const height =
            isPrivate && this.state.isPrivateSession
                ? "150px"
                : document.getElementsByClassName("video-container")[0] !== undefined
                ? `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                }px`
                : "300px";

        const width =
            isPrivate && this.state.isPrivateSession
                ? "150px"
                : document.getElementsByClassName("video-container")[0] !== undefined
                ? `${document.getElementsByClassName("video-container")[0].offsetWidth}px`
                : "300px";

        const pub = (
            <Publisher
                setElapsedTime={this.setElapsedTime}
                isCountdownRequired={true}
                toggleEndSessionModal={() => this.toggleEndSessionModal}
                history={this.props.history}
                setOTSession={this.setOTSession}
                height={height}
                width={width}
                video={this.state.video}
                audio={this.state.audio}
                shareScreen={this.state.screenShare}
                videoSourceIndex={this.state.videoSourceIndex}
                audioSourceIndex={this.state.audioSourceIndex}
                videoSource={this.state.videoSource}
                audioSource={this.state.audioSource}
                onInit={(publisher) => {
                    this.publisherRef = publisher;
                }}
                onPublish={() => {
                    vuePayLog("StartBroadcast", "onPublish");
                    updateVideoDimensions();
                    setTimeout(() => {
                        if (this.state.videoSourceIndex === -1) {
                            this.changeVideo(0);
                        }
                    }, 1000);
                    //do a delay and change the video to index
                }}
                onError={this.onPublishError}
                toggleScreenShare={this.toggleScreenShare}
            />
        );

        return pub;
    };

    showSubscriber = (isPrivate) => {
        const height = !isPrivate
            ? "150px"
            : document.getElementsByClassName("video-container")[0] !== undefined
                ? `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                    }px`
                : "300px";

        const sub = (
            <div>
                <OTStreams>
                    <Subscriber
                        history={this.props.history}
                        onSubscribe={() => vuePayLog("StartViewBroadcast", "onInit")}
                        onError={(e) => vuePayLog("StartBroadcast", "onError", e)} height={height}>
                    </Subscriber>
                </OTStreams>

                {
                    this.state.oneOnOneFirebaseData && this.state.oneOnOneFirebaseData.hasOwnProperty("profile_pic") &&
                    <div className="waiting-screen" style={{height: height}}>
                        <div className="mask-outer">
                            <div className="mask-inner">
                                <img src={this.state.oneOnOneFirebaseData.profile_pic} alt="user-profile-pic"
                                     width={96} style={{borderRadius: '50%'}}/>
                            </div>
                        </div>
                        <div className="waiting-screen-content">
                            <div className="waiting-screen-title">{this.state.oneOnOneFirebaseData.title}</div>
                            <div className="waiting-screen-description">{this.state.oneOnOneFirebaseData.message}</div>
                            {
                                this.state.oneOnOneFirebaseData.id !== -1 && this.state.oneOnOneFirebaseData.user_acceptance !== "timeout" &&
                                <div className="waiting-screen-description"
                                     style={{fontStyle: 'normal'}}>{this.state.countDownToRejectTheRequest}</div>
                            }

                        </div>
                    </div>
                }
            </div>
        );

        return sub;
    };
    /**
     * @function toggles the state of dropdown menu
     */
    dropDownClickListener = () => {
        // document.getElementsByClassName("dropdown")[1].classList.toggle("show");
        document.getElementsByClassName("popover_menucontent")[1].classList.show();
        // this.state.globalPublisher.cycleVideo();
        // //console.log("working");
    };

    isBroadcasterVerified = () => {
        return (
            this.props.account_management.userDetails !== null &&
            this.props.account_management.userDetails !== undefined &&
            this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].is_verified === 1
        );
    };


    toggleRightLayout = (layoutType) => {
        //chat, onetoone, group, tip, tip_goal
        let _layoutType = "";
        if (layoutType !== this.state.activeRightLayout) {
            _layoutType = layoutType
        }

        this.setRightLayout(_layoutType);
    };

    setRightLayout = (layoutType) => {
        //chat, onetoone, group, tip, tip_goal
        this.setState({
            activeRightLayout: layoutType
        }, () => {
            updateVideoDimensions();
            this.updateNotification(layoutType, false);
            if (this.state.activeRightLayout === "tip") {
                getData(LOGIN).then((data) => {

                    if (!isEmpty(data)) {
                        this.props.getTipDataList(
                            data.token,
                            data.api_token,
                            this.state.broadcast.id,
                        );
                    }
                });
            } else if (this.state.activeRightLayout === "tipgoal") {
                getData(LOGIN).then((data) => {

                    if (!isEmpty(data)) {
                        this.props.getTipDataListForTipGoal(
                            data.token,
                            data.api_token,
                            this.state.broadcast.id.toString(),
                            this.state.broadcast.tip_goal[0].id
                        );
                    }
                });
            }
        });
    };

    shakeTheTipIcon = () => {
        //apply the shake class and then remove it
        const ref = this;
        ref.setState({
            isTipIconShaking: true
        }, () => {
            setTimeout(() => {
                ref.setState({
                    isTipIconShaking: false
                })
            }, 3000);
        });
    };

    getClassName = (key)=>{
        if(key === "video-parent-container"){
            if(this.state.innerWidth > 0 && this.state.innerWidth <= 1300){
                return className("video-parent-container col-xl-12")
            }else{
                return className("video-parent-container", {
                    "col-xl-8": this.state.activeRightLayout !== "",
                    "col-xl-12": this.state.activeRightLayout === ""
                })
            }
        }
    }
    render() {
        const videoClass = className("btn-controls", "video", {
                active: this.state.video,
            }),
            audioClass = className("btn-controls", "volume", {
                active: this.state.audio,
            }),
            cameraToggle = className(
                "btn-controls",
                "cameraToggle",
                "popover__title",
                {active: this.state.videoSourceIndex !== 0}
            ),
            audioToggle = className("btn-controls", "audioToggle", "popover__title"),
            moreToggle = className("btn-controls", "moreToggle", "popover__title"),
            screenShareClass = className("btn-controls", "screenShare", {
                active: this.state.screenShare,
            });

        const funForSessions = () => {
            return (
                <div id={"funForSessions"}>
                    {this.whenPrivateSession()}
                    {this.showPublisherSubscriberSession(true)}
                </div>
            );
        };

        return (
            <div>

                <ReactAudioPlayer
                    id={"notification-sound"}
                    src={assets.pristine_audio}
                />

                <CommonModal
                    toggleCommonModal={this.toggleCommonModal}
                    hideCrossButton={true}
                    message={this.state.commonModalMsg}
                />

                <ExitSessionModal
                    toggleEndSessionModal={this.toggleEndSessionModal}
                    disconnectOTSession={this.disconnectOTSessionAndNavigateToHomeScreen}
                    viewerLeftSession={this.state.viewerLeftSession}
                    hideCrossButton={this.state.viewerLeftSession}
                />

                {this.state.clicked_user_details && (
                    <InviteForSessionModal
                        initialValues={this.state.broadcast}
                        setInteractedViewerID={this.setInteractedViewerID}
                        oneToOneRequestArray={this.state.oneToOneRequest}
                        is_invite_sent={this.state.is_invite_sent}
                        toggleInviteForSessionModal={this.toggleInviteForSessionModal}
                        toggleCommonModal={this.toggleCommonModal}
                        userDetails={this.state.clicked_user_details}
                        broadcastId={this.state.broadcast_id}
                        broadcast={this.state.broadcast}
                        privateRequestSentToViewer={this.state.privateRequestSentToViewer}
                        userDataOfPrivateRequestSentToViewer={
                            this.state.userDataOfPrivateRequestSentToViewer
                        }
                        favouriteUnFavouriteUser={this.favouriteUnFavouriteUser}
                        blockOnUnblockViewer={this.blockOnUnblockViewer}
                        availabilityID={this.state.availability_id}
                        private_broadcast_id={this.state.private_broadcast_id}
                    />
                )}

                <main role="main" className="">
                    {this.state.session_id !== null && (
                        <div className="broadcast-container broadcasting">

                            <TopSection
                                innerWidth={this.state.innerWidth}
                                notification={this.state.notification}
                                broadcast={this.state.broadcast}
                                type={"broadcaster"}
                                activeRightLayout={this.state.activeRightLayout}
                                toggleRightLayout={this.toggleRightLayout}/>

                            {/*video & live chat row starts */}
                            <div className="row">
                                <div className={this.getClassName("video-parent-container")}>

                                    {/*Viewer count and elapsed time*/}
                                    <div className="elaspsed-time-countdown">
                                        <Row className="no-margin no-padding">
                                            <Col md="2" className="video-screen-views">

                                                {
                                                    this.state.private_broadcast_id === -1 ?
                                                        <div className="elaspsed-time-countdown-box-for-img-span">
                                                            <img src={assets.group_views} alt="views"
                                                                 className="center-img"/>
                                                            <span className="elaspsed-time-countdown-text"
                                                                  style={{paddingLeft: 3}}>{this.state.connectionArray.length}</span>
                                                        </div>
                                                        :
                                                        <div className="elaspsed-time-countdown-box-for-img-span">
                                                            <img src={assets.private_views} alt="views"
                                                                 className="center-img"/>
                                                        </div>
                                                }


                                            </Col>
                                            <Col md="2">
                                                <div className="elaspsed-time-countdown-parent">
                                                    <p className="elaspsed-time-countdown-text"> {this.state.elapsed_time} </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    {/*Viewer count and elapsed time*/}

                                    {/*Earnings for broadcaster*/}
                                    <div className="earnings-parent">
                                        <p className="elaspsed-time-countdown-text">
                                            {
                                                getSessionStatus(this.state.broadcast, this.props.get_broadcast_earnings, this.state.currency_symbol, this.state.total, this.state.private_broadcast_id)
                                            }
                                        </p>
                                    </div>
                                    {/*Earnings for broadcaster*/}

                                    {/*Video controls for broadcaster*/}
                                    <div className="video-wrapper">
                                        {/*video element starts */}
                                        <div className="video-container">
                                            <div className="broadcaster-control-panel">
                                                <div
                                                    className={videoClass}
                                                    onClick={this.toggleVideo}
                                                />
                                                <div
                                                    className={audioClass}
                                                    onClick={this.toggleAudio}
                                                />
                                                <div
                                                    className={screenShareClass}
                                                    onClick={this.toggleScreenShare}
                                                />

                                                {/*for audio switch*/}
                                                {
                                                    this.state.audioDevices.length > 0 && (
                                                        <div className={"popover__wrapper btn-controls "}>
                                                            <div className={[audioToggle]} id="dropdownMenu3"/>
                                                            <div className={"popover__content"}>
                                                                <ul className="popover_menucontent"
                                                                    aria-labelledby="myDropdown">
                                                                    {this.state.audioDevices.map(
                                                                        (device, index) => {
                                                                            return (
                                                                                <li
                                                                                    className="camera-li"
                                                                                    key={device.deviceId}
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        onClick={(ev) => {
                                                                                            ev.preventDefault();
                                                                                            this.changeAudio(index);
                                                                                        }}
                                                                                        className="dropdown-item"
                                                                                    >
                                                                                        {device.label}
                                                                                    </a>
                                                                                </li>
                                                                            );
                                                                        }
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                {/*for audio switch*/}

                                                {/*for video switch*/}
                                                {
                                                    this.state.videoDevices.length > 0 &&
                                                    (
                                                        <div className={"popover__wrapper btn-controls "}>
                                                            <div className={[cameraToggle]} id="dropdownMenu2"/>
                                                            <div className={"popover__content"}>
                                                                <ul
                                                                    className="popover_menucontent"
                                                                    aria-labelledby="myDropdown"
                                                                >
                                                                    {this.state.videoDevices.map((device, index) => {
                                                                        return (
                                                                            <li
                                                                                className="camera-li"
                                                                                key={device.deviceId}
                                                                            >
                                                                                <a
                                                                                    href="#"
                                                                                    onClick={(ev) => {
                                                                                        ev.preventDefault();
                                                                                        this.changeVideo(index);
                                                                                    }}
                                                                                    className="dropdown-item"
                                                                                >
                                                                                    {device.label}
                                                                                </a>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                {/*for video switch*/}

                                                {
                                                    this.state.moreMenu.length > 0 && (
                                                        <div className={"popover__wrapper btn-controls "}>
                                                            <div className={[moreToggle]} id="dropdownMenu5"/>
                                                            <div className={"popover__content"}>
                                                                <ul className="popover_menucontent"
                                                                    aria-labelledby="myDropdown">
                                                                    {this.state.moreMenu.map(
                                                                        (menu, index) => {
                                                                            return (
                                                                                <li
                                                                                    className="camera-li"
                                                                                    key={menu.id}
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        onClick={(ev) => {
                                                                                            ev.preventDefault();
                                                                                            if (menu.id === "change-broadcast") {
                                                                                                this.setRightLayout("change-broadcast")
                                                                                            }
                                                                                        }}
                                                                                        className="dropdown-item"
                                                                                    >
                                                                                        {menu.label}
                                                                                    </a>
                                                                                </li>
                                                                            );
                                                                        }
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                {/*for audio switch*/}

                                                {this.state.isFullScreen === false && (
                                                    <div
                                                        className="btn-controls cancel"
                                                        onClick={this.toggleEndSessionModal}
                                                    />
                                                )}
                                            </div>
                                            {this.state.isFullScreen === false && (
                                                <div
                                                    className="btn-controls fullscreen"
                                                    onClick={this.requestFullScreen}
                                                />
                                            )}
                                            {this.state.private_broadcast_id !== -1
                                                ? funForSessions()
                                                : this.showPublisherSubscriberSession()}
                                        </div>
                                        {/*video element ends */}

                                        {/*TODO remove me*/}
                                        {/*<VideoTabBarButton*/}
                                        {/*isBroadcasterVerified={this.isBroadcasterVerified()}*/}
                                        {/*broadcast={this.state.broadcast}*/}
                                        {/*setTabActiveIndex={this.setTabActiveIndex}*/}
                                        {/*tabActiveIndex={this.state.tabActiveIndex}*/}
                                        {/*group_request={this.state.groupRequest.length}*/}
                                        {/*one_on_one_request={this.state.oneToOneRequest.length}*/}
                                        {/*availabilityID={this.state.availability_id}*/}
                                        {/*/>*/}
                                    </div>
                                    {/*Video controls for broadcaster*/}
                                </div>
                                <div className="w-100 d-block d-xl-none mt-3"/>

                                {
                                    this.state.activeRightLayout === 'chat' &&
                                    this.otSession.current !== null && (
                                        <ChatComponent
                                            setUserData={this.setUserData}
                                            toggleInviteForSessionModal={
                                                this.toggleInviteForSessionModal
                                            }
                                            session={this.otSession.current.sessionHelper.session}
                                            signalArray={this.state.signalArray}
                                            userType={"Publisher"}
                                            actionsAllowed={true}
                                            setRightLayout={this.setRightLayout}
                                        />
                                    )
                                }

                                {
                                    (this.state.activeRightLayout === 'onetoone' || this.state.activeRightLayout === 'group') && (
                                        <RequestComponent
                                            location={this.props.location}
                                            history={this.props.history}
                                            activeRightLayout={this.state.activeRightLayout}
                                            setRightLayout={this.setRightLayout}

                                            availabilityID={this.state.availability_id}

                                            setInteractedViewerID={this.setInteractedViewerID}
                                            initialValues={this.state.broadcast}
                                            broadcast={this.state.broadcast}
                                            toggleCommonModal={this.toggleCommonModal}

                                            oneToOneRequestArray={this.state.oneToOneRequest}
                                            groupRequestArray={this.state.groupRequest}
                                            disconnectFromTokBoxAndChangeBroadcast={
                                                this.disconnectFromTokBoxAndChangeBroadcast
                                            }

                                            isBroadcasterVerified={this.isBroadcasterVerified()}
                                            updateBroadcasterType={this.updateBroadcasterType}
                                        />
                                    )
                                }


                                {
                                    (this.state.activeRightLayout === 'tip') && (
                                        <TipComponent
                                            setRightLayout={this.setRightLayout}
                                            tip={this.props.tip}
                                            showHeader
                                        />
                                    )
                                }

                                {
                                    (this.state.activeRightLayout === 'tipgoal') && (
                                        <TipGoalComponent
                                            setRightLayout={this.setRightLayout}
                                            tip={this.state.tip}
                                            tipGoalData={this.state.tipGoalData}
                                            tipGoalPurpose={this.state.tipGoalPurpose}
                                        />
                                    )
                                }

                                {
                                    (this.state.activeRightLayout === 'change-broadcast') &&
                                    this.state.broadcast &&
                                    <ChangeBroadcastComponent
                                        setRightLayout={this.setRightLayout}
                                        isBroadcasterVerified={this.isBroadcasterVerified()}
                                        initialValues={this.state.broadcast}
                                        createBroadcast={this.createBroadcast}
                                        disconnectFromTokBoxAndChangeBroadcast={
                                            this.disconnectFromTokBoxAndChangeBroadcast
                                        }
                                    />
                                }
                            </div>
                            {/*video & live chat row ends */}

                        </div>
                    )}

                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        broadcast: state.broadcast,
        get_broadcast_earnings: state.get_broadcast_earnings,
        broadcaster_detail_management: state.broadcaster_detail_management,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_block_unblock_viewer: state.broadcaster_block_unblock_viewer,
        device: state.device.payload,
        tip: state.tip,
        tokbox: state.tokbox,
        showTipListModalFlag: state.flag.showTipListModalFlag,
        availability: state.availability
    };
}

export default connect(mapStateToProps, actions)(StartBroadcast);
